export default __webpack_public_path__ + "static/media/brgPopupFN.0381a258.png";